import { Flex } from 'antd';
import { memo } from 'react';

import { Button, ButtonVariant, Modal, Typography } from '@/shared/ui';

import { useDeleteUserRequest } from '@/pages/UserAccount/UserRequests/model';

import { UserRequest } from '@/api/types';

interface Props {
  draftIdToDelete: UserRequest['id'];
  isModalOpen: boolean;
  closeModal: () => void;
}

export const ConfirmDeleteUserRequestDraftModal = memo<Props>(function ({ draftIdToDelete, isModalOpen, closeModal }) {
  const { mutate: deleteRequest, isPending } = useDeleteUserRequest();

  return (
    <Modal
      open={isModalOpen}
      size="md"
      title="Ви видаляєте чернетку"
      centered
      closable
      onCancel={closeModal}
      footer={
        <Flex gap={12}>
          <Button onClick={closeModal}>Не видаляти</Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            disabled={isPending}
            onClick={(): void => {
              deleteRequest(draftIdToDelete, { onSuccess: closeModal });
            }}
          >
            <Typography color="red">Видалити чернетку</Typography>
          </Button>
        </Flex>
      }
    >
      <Typography color="graphite">
        Чернетку буде видалено назавжди. Ви впевнені, що хочете видалити цю чернетку?
      </Typography>
    </Modal>
  );
});
